import SuperFetch from '../../superFetch.js';

class RemoteImageApi {
  /**
   *  원격 스플래시 이미지 리스트 요청하기
   */
  getRemoteImageSplashList = (data) => SuperFetch.post('/remoteImage/splash/list', data);

  /**
   *  원격 레퍼럴 이미지 리스트 요청하기
   */
  getRemoteImageReferralList = (data) => SuperFetch.post('/remoteImage/referral/list', data);

  /**
   *  원격 스플래시 이미지 상세 정보 요청하기
   */
  getRemoteImageSplashDetail = (data) => SuperFetch.post('/remoteImage/splash/detail', data);

  /**
   *  원격 레퍼럴 이미지 상세 정보 요청하기
   */
  getRemoteImageReferralDetail = (data) => SuperFetch.post('/remoteImage/referral/detail', data);

  /**
   *  원격 스플래시 이미지 등록 요청하기
   */
  createRemoteImageSplash = (data) => SuperFetch.post('/remoteImage/splash/insert', data);

  /**
   *  원격 레퍼럴 이미지 등록 요청하기
   */
  createRemoteImageReferral = (data) => SuperFetch.post('/remoteImage/referral/insert', data);

  /**
   *  원격 스플래시 이미지 수정 요청하기
   */
  editRemoteImageSplash = (data) => SuperFetch.post('/remoteImage/splash/edit', data);

  /**
   *  원격 레퍼럴 이미지 수정 요청하기
   */
  editRemoteImageReferral = (data) => SuperFetch.post('/remoteImage/referral/edit', data);
}

export default new RemoteImageApi();
